import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";
import { PROCESS } from "@/data/site";

export default function ProcessTimeline({ showHeader = true }) {
  return (
    <section className="bg-white py-20 lg:py-28" data-testid="process-section" id="process">
      <div className="dq-container">
        {showHeader && (
          <SectionHeader
            center
            eyebrow="How we work"
            title="A proven process for"
            highlight="predictable growth"
            subtitle="Seven deliberate steps that take you from where you are to where you want to be."
          />
        )}

        <div className="relative mt-16">
          {/* connecting line */}
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-dq-line to-transparent lg:block" aria-hidden="true" />
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-7 lg:gap-4">
            {PROCESS.map((step, i) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="relative text-center lg:text-left"
                data-testid={`process-step-${i + 1}`}
              >
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-dq-line bg-white text-dq-orange dq-shadow-soft lg:mx-0">
                  <step.icon className="h-6 w-6" />
                </div>
                <div className="mt-4 text-xs font-bold uppercase tracking-widest text-dq-orange">
                  Step {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-1 font-display text-lg font-bold text-dq-ink">{step.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-dq-muted">{step.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
